export default __webpack_public_path__ + "static/media/ProtocolOverview-icon.812d437b.svg";